import React, { useState,useEffect } from 'react';
import { Row, Col, Input, Form, Select, Button } from 'antd';
import TextArea from '../../../../ui/TextArea'
import Collapse, { Panel } from '../../../../ui/Collapse';
import { PlusOutlined } from '@ant-design/icons';
import { EnvironmentalImpact } from '../WaterUsageInterface/WaterUsageInterface';
import { Uom, YesOrNoOptions } from '../helpers'

interface propsTypes {
  dataList: EnvironmentalImpact,
  currentForm: { setFieldsValue: (field: {}) => void },
  setWaterListEdited?:any,
  panesData: any
}

const FormItem = Form.Item
const Option = Select.Option

const GeneralEdit = (props: propsTypes) => {
 

  const [panelList, setPanelList] = useState<Array<{desc ?:string}>>([{desc:''}])
  const [refreshCount, setRefreshCount] = useState(0);

  useEffect(()=>{
    const data = props?.dataList?.environmentalimpact?.waterusage?.description;
    setPanelList(!!data?.length ? data : [{ desc: '' }])
  },[props?.dataList?.environmentalimpact?.waterusage?.description])


  const addClick = () => {
    props.setWaterListEdited(true) 
    const newpanelList = panelList?.concat([{ desc: '' }]);
    setPanelList(newpanelList);
    setRefreshCount(refreshCount + 1);
  }

  const closeClick = (index: number) => {
    const validData = panelList?.filter((item: { desc?: string }, i: number) => item.desc)
    if (validData && validData.length > 1) {
      const _panelList = JSON.parse(JSON.stringify(panelList))
      _panelList[index].desc = null;
      if (_panelList.indexOf(_panelList[index]) < _panelList.length - 1) {
        props.currentForm.setFieldsValue({
          [`desc-${index + 1}`]: _panelList[index].desc
        })
      } else {
        props.setWaterListEdited(true)
        props.currentForm.setFieldsValue({
          [`desc-${index}`]: ''
        })
      }
      _panelList.splice(index, 1)
      setPanelList(_panelList)
    }
  }

  const handleChange = (value : string, index: number) => {
    panelList[index].desc = value
    // persit panels data, lifting state up
    props.panesData(panelList)
    props.setWaterListEdited(true)
  }

  useEffect(() => {
    props.panesData(panelList)
  },[panelList, props])

  return (
    <>
      <Row gutter={24} style={{ paddingLeft: 2 }}>
        <Col span={6}>
          <FormItem name="greywaterecycling" label="Gray Water Recycling">
            <Select allowClear showSearch>
              {
                YesOrNoOptions.map((opt: { value: string, label: string }, index) => (
                  <Option key={index} value={opt.value}>{opt.label}</Option>
                ))
              }
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem name="waterconservation" label="Water Conservation">
            <Select allowClear showSearch>
              {
                YesOrNoOptions.map((opt: { value: string, label: string }, index) => (
                  <Option key={index} value={opt.value}>{opt.label}</Option>
                ))
              }
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem
            name="waterdiversion"
            label="Waste Diversion(%)"
            rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}
            // extra={<span className="blue-font">In Months</span>}
          >
            <Input />
          </FormItem>
        </Col>
        <Col span={5}></Col>
        <Col span={6}>
          <FormItem name="uom" label="Unit of Measure">
            <Select allowClear showSearch>
              {
                Uom.map((opt: { value: string, label: string }, index) => (
                  <Option key={index} value={opt.value}>{opt.label}</Option>
                ))
              }
            </Select>
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem
            name="perroomnightperiod"
            label="Per Room Night Time Period"
            rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}
            extra={<span className="blue-font">In Months</span>}
          >
            <Input />
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem
            name="perroomdayperiod"
            label="Per Room Day Time Period"
            rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}
            extra={<span className="blue-font">In Months</span>}
          >
            <Input />
          </FormItem>
        </Col>
        <Col span={5}></Col>
        <Col span={6}>
          <FormItem
            name="waterdiversionrateperiod"
            label="Waste Diversion Rate Time Period"
            rules={[{ pattern: /^\d*?$/, message: "This field should be a number." }]}
            extra={<span className="blue-font">In Months</span>}
          >
            <Input />
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem
            name="perroomnight"
            label="Per Room Night"
            rules={[{ pattern: /^\d*\.?\d*$/, message: "This field should be a number." }]}
          >
            <Input />
          </FormItem>
        </Col>
        <Col span={6}>
          <FormItem
            name="perroomday"
            label="Per Room Day"
            rules={[{ pattern: /^\d*\.?\d*$/, message: "This field should be a number." }]}
          >
            <Input />
          </FormItem>
        </Col>
      </Row>


      <Collapse defaultActiveKey={panelList?.map((_:{ desc?: string },i)=> i)} multiCollapseButton key={refreshCount}>
        {panelList && panelList.map((item: { desc?: string }, i: number) =>
          <React.Fragment key={i}>
            {
             <Panel
                  header={`Water Usage Program ${i + 1}`}
                  key={i}
                  style={{ marginBottom: '20px' }}
                  deleteButton={{
                    action: () => closeClick(i),
                    title: `Are you sure you want to delete Water Usage Program ${i + 1}?`,
                  }}
                >
                  <Row gutter={24}>
                    <Col span={18}>
                      <Form.Item
                        name={`desc-${i}`}
                        label='Description'
                        rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                      >
                        <TextArea onChange={(e) => handleChange(e.target.value, i)} maxLength={300} maxRows={3} style={{ resize: 'none' }} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
            }
          </React.Fragment>
        )}
      </Collapse>
      <Button
        type="link"
        onClick={addClick}
        icon={<PlusOutlined />}
        style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
      >
        {`Add Water Usage Program ${panelList && panelList.length + 1}`}
      </Button>
    </>
  )
}


export default GeneralEdit;
